import React, {
  createContext,
  useState,
  useCallback,
  useEffect,
  memo,
  Fragment,
} from 'react'
import cn from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import MuiSnackbar from '@material-ui/core/Snackbar'
import Alert from '@material-ui/lab/Alert'

import { styles } from './styles'

export const SnackBarContext = createContext()

const SnackBar = ({ classes, children }) => {
  const [snackPack, setSnackPack] = useState([])
  const [open, setOpen] = useState(false)
  const [messageInfo, setMessageInfo] = useState(undefined)

  useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo({ ...snackPack[0] })
      setSnackPack(prev => prev.slice(1))
      setOpen(true)
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false)
    }
  }, [snackPack, messageInfo, open])

  const runSnackBar = useCallback(state => {
    setSnackPack(prev => [...prev, state])
  }, [])

  const {
    vertical = 'bottom',
    horizontal = 'right',
    msg = '',
    error = '',
    icon = null,
    type,
    newDesign,
    autoHideDuration = 6000,
    paddingTop73 = null,
  } = messageInfo || {}

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpen(false)
  }

  const handleExited = () => {
    setMessageInfo(undefined)
  }

  const renderAlert = () => {
    if (!type) return

    return (
      <Alert onClose={handleClose} severity={type}>
        {newDesign ? (
          <div className={classes.snackbarMessage}>
            {icon} <span>{msg}</span>
          </div>
        ) : (
          <Fragment>
            {msg}
            <br />
            {error}
          </Fragment>
        )}
      </Alert>
    )
  }

  return (
    <div
      className={
        newDesign
          ? cn(classes.root, vertical === 'top' ? classes.paddingTop : {})
          : paddingTop73
          ? classes.paddingTop73
          : {}
      }
    >
      <MuiSnackbar
        key={(messageInfo && messageInfo.type) || undefined}
        anchorOrigin={{
          vertical: vertical,
          horizontal: horizontal,
        }}
        open={open}
        autoHideDuration={autoHideDuration}
        onClose={handleClose}
        TransitionProps={{ onExited: handleExited }}
      >
        {renderAlert()}
      </MuiSnackbar>
      <SnackBarContext.Provider value={runSnackBar}>
        {children}
      </SnackBarContext.Provider>
    </div>
  )
}

export default memo(withStyles(styles)(SnackBar))
